<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">Edit {{module}}</h4>
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-item">
                <router-link :to="{name:'dashboards'}">Dashboards</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link :to="{name:table_module}">{{ module }}</router-link>
              </li>
              <li class="breadcrumb-item active">Edit</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row">
      <div class="col-12 grid-margin">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Edit {{ module }}</h4>
            <form class="form-sample" @submit.prevent="save()">
              <!-- <p class="card-description">Personal info</p> -->
              <div class="row">
                <div class="col-md-6" v-for="(item, index) in fields" :key="index">
                  <div class="form-group">
                    <label>{{ item[alias_table+'_f_label'] }}</label>
                    <small
                      v-if="item[alias_table+'_f_validation'] != ''"
                      class="pull-right text-danger"
                    >*{{ item[alias_table+'_f_validation'] }}</small>
                    <component
                      :is="item[alias_table+'_f_input_type']+'_form'"
                      :name="item[alias_table+'_f_name']"
                      :validation="item[alias_table+'_f_validation']"
                      :content="item['content']"
                      :dropdown_name="item[alias_table+'_f_options']"
                      :disabled="disableEmail(item)"
                      @post="bindingData"
                    ></component>
                  </div>
                </div>
              </div>
              <button type="submit" class="btn btn-primary mr-2">Submit</button>
              <router-link class="btn btn-danger" :to="{name : table_module}">Cancel</router-link>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import text_form from "@/components/input/text";
import longtext_form from "@/components/input/longtext";
import number_form from "@/components/input/number";
import option_form from "@/components/input/option";
import s_autocomplete_form from "@/components/input/single_autocomplete";
import m_autocomplete_form from "@/components/input/multiple_autocomplete";
import phone_form from "@/components/input/phone";
import time_form from "@/components/input/time";
import datetime_form from "@/components/input/datetime";
import money_form from "@/components/input/money";
import email_form from "@/components/input/email";
import s_image_form from "@/components/input/s_image";

export default {
  data() {
    return {
      module: "Pengguna",
      table_module: "customers",
      alias_table: "usr",
      fields: {},
      uuid: this.$route.params.uuid,
      post: {}
    };
  },
  components: {
    text_form,
    longtext_form,
    number_form,
    option_form,
    s_autocomplete_form,
    phone_form,
    time_form,
    datetime_form,
    money_form,
    m_autocomplete_form,
    email_form,
    s_image_form
  },
  mounted() {
    this.axios
      .get("/users/edit/" + this.uuid)
      .then(response => {
        this.fields = response.data.data;
      })
      .catch(error => {
        if (error.response) {
          this.$router.push({ name: this.table_module });
        } else if (error.request) {
          console.log("Error", error.message);
        } else {
          console.log("Error", error.message);
        }
      });
  },
  methods: {
    bindingData: function(value) {
      if (value["value"] == null || value["value"] == "") {
        this.$delete(this.post, value["name"]);
      } else {
        this.$set(this.post, value["name"], value["value"]);
      }
    },
    save: function() {
      const uuid = this.$route.params.uuid;

      this.axios
        .post("/users/updatebyAdmin/" + uuid, this.post)
        .then(response => {
          if (response.data.status == 200) {
            this.$toast("Update data berhasil");
            this.$router.push({ name: this.table_module });
          }
        }).catch((error) => {
          if (error.response) {
            if (error.response.status == 500) {
              this.$toast.error("Email sudah ada");
            }
          }
        });
    },
    disableEmail(item){
      let result = false
      if(item.usr_f_name == "usr_email"){
        if(item.content !== null && item.content !== ''){
          result = true
        }
      }
      return result
    }
  }
};
</script>